if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');

        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          // IMPORTANT: do NOT move thumbnails anymore.
          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }

          // Pocket Blessing variants share gallery media, so keep mobile shoppers at the option picker.
          const disableMobileVariantScroll =
            prepend && !this.mql.matches && this.dataset.disableMobileVariantScroll === 'true';
          if (disableMobileVariantScroll) return;

          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });

        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;

        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);

        // CRITICAL FIX: if a data-target ever points to a slide that is not present,
        // we do not crash the whole gallery.
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
          this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);

        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

announceLiveRegion(activeItem, position) {
  const image = activeItem.querySelector('.product__modal-opener--image img');
  if (!image) return;

  const announce = () => {
    this.elements.liveRegion.setAttribute('aria-hidden', false);
    this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
    setTimeout(() => {
      this.elements.liveRegion.setAttribute('aria-hidden', true);
    }, 2000);
  };

  // If already loaded, announce immediately.
  // Otherwise announce once on load, without forcing a reload.
  if (image.complete && image.naturalWidth > 0) {
    announce();
  } else {
    image.addEventListener('load', announce, { once: true });
  }
}

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}
/* PWG gallery crossfade: add once at the end of media-gallery.js */
(() => {
  const states = new WeakMap();
  const reducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const photo = (item) =>
    item?.querySelector('.product__modal-opener--image img');

  function clear(gallery) {
    const state = states.get(gallery);
    if (!state) return;

    states.delete(gallery);
    clearTimeout(state.timer);
    state.animation?.cancel();
    state.layer.remove();
    gallery.style.position = state.position;

    window.removeEventListener('resize', state.cancel);
    gallery.removeEventListener('touchstart', state.cancel);
  }

  function capture(gallery, targetId) {
    if (!gallery) return;

    const existing = states.get(gallery);
    if (existing && !existing.animation) return;
    if (existing) clear(gallery);

    const viewer = gallery.elements?.viewer;
    const current = viewer?.querySelector(
      '[data-media-id].is-active'
    );

    if (!current || current.dataset.mediaId === targetId) return;

    const image = photo(current);
    if (!image?.complete || !image.naturalWidth) return;

    const bounds = image.getBoundingClientRect();
    const frame = viewer.getBoundingClientRect();

    if (
      !bounds.width ||
      !bounds.height ||
      frame.bottom <= 0 ||
      frame.top >= innerHeight
    ) return;

    const origin = gallery.getBoundingClientRect();
    const layer = document.createElement('div');

    layer.setAttribute('aria-hidden', 'true');
    layer.dataset.pwgCrossfade = '';

    Object.assign(layer.style, {
      position: 'absolute',
      pointerEvents: 'none',
      overflow: 'hidden',
      zIndex: '3',
      left: `${frame.left - origin.left}px`,
      top: `${frame.top - origin.top}px`,
      width: `${frame.width}px`,
      height: `${frame.height}px`,
      background: 'transparent'
    });

    const copy = document.createElement('img');
    copy.alt = '';
    copy.src = image.currentSrc || image.src;

    const style = getComputedStyle(image);

    Object.assign(copy.style, {
      position: 'absolute',
      margin: '0',
      maxWidth: 'none',
      left: `${bounds.left - frame.left}px`,
      top: `${bounds.top - frame.top}px`,
      width: `${bounds.width}px`,
      height: `${bounds.height}px`,
      objectFit: style.objectFit,
      objectPosition: style.objectPosition
    });

    layer.append(copy);

    const state = {
      layer,
      position: gallery.style.position,
      version: 0
    };

    state.cancel = () => clear(gallery);

    if (getComputedStyle(gallery).position === 'static') {
      gallery.style.position = 'relative';
    }

    gallery.append(layer);
    states.set(gallery, state);

    state.timer = setTimeout(state.cancel, 8000);

    window.addEventListener('resize', state.cancel, {
      once: true
    });

    gallery.addEventListener('touchstart', state.cancel, {
      once: true,
      passive: true
    });
  }

  async function reveal(gallery, targetId) {
    const state = states.get(gallery);
    if (!state) return;

    const version = ++state.version;

    const target = Array.from(
      gallery.elements.viewer.querySelectorAll('[data-media-id]')
    ).find((item) => item.dataset.mediaId === targetId);

    const image = photo(target);

    if (!image) {
      clear(gallery);
      return;
    }

    // Load only the selected image; other images stay lazy.
    image.loading = 'eager';

    try {
      await image.decode();
    } catch (_) {
      // Keep Dawn's normal fallback if the image fails.
    }

    if (
      states.get(gallery) !== state ||
      state.version !== version
    ) return;

    if (
      reducedMotion.matches ||
      !image.naturalWidth ||
      !state.layer.animate
    ) {
      clear(gallery);
      return;
    }

    state.animation = state.layer.animate(
      [{ opacity: 1 }, { opacity: 0 }],
      {
        duration: 180,
        easing: 'ease-out',
        fill: 'forwards'
      }
    );

    state.animation.finished
      .then(() => {
        if (states.get(gallery) === state) clear(gallery);
      })
      .catch(() => {});
  }

  customElements.whenDefined('media-gallery').then(() => {
    const prototype = customElements.get('media-gallery').prototype;

    if (prototype.pwgCrossfadeInstalled) return;
    prototype.pwgCrossfadeInstalled = true;

    const original = prototype.setActiveMedia;

    prototype.setActiveMedia = function (mediaId, prepend) {
      capture(this, mediaId);

      try {
        const result = original.call(this, mediaId, prepend);
        void reveal(this, mediaId);
        return result;
      } catch (error) {
        clear(this);
        throw error;
      }
    };
  });

  customElements.whenDefined('product-info').then(() => {
    const prototype = customElements.get('product-info').prototype;

    if (prototype.pwgCrossfadeInstalled) return;
    prototype.pwgCrossfadeInstalled = true;

    const original = prototype.updateMedia;

    prototype.updateMedia = function (html, featuredId) {
      const gallery = this.querySelector('media-gallery');

      // Capture before Dawn removes or reorders variant slides.
      if (featuredId) {
        capture(gallery, `${this.dataset.section}-${featuredId}`);
      }

      try {
        return original.call(this, html, featuredId);
      } catch (error) {
        if (gallery) clear(gallery);
        throw error;
      }
    };
  });
})();